import React, { useContext, useState, useEffect } from 'react';
import TypeDescriber from '../TypeDescriber';
import Cards from '../cards/Cards';
import '../css/App.css';
import { CartContext } from '../cart/ContextProvider';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useLocation } from 'react-router-dom';
import Loader from '../common/Loader';

function SearchResult(props) {
  const { initialLoading,searchResult } = useContext(CartContext);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    setLoading(true)
    console.log();
   setTimeout(()=>{
    setLoading(false)
   },1500)
  }, [searchResult]);

  return (
    <div className='totalContent searchResultPage'>
      {loading  || initialLoading? (
        <Loader />
      ) : (
        <>
          <div className='typeDes'>
            <div className='typeDes-item'>
              <TypeDescriber location={location.pathname + " result"} />
            </div>
          </div>

          <div className='content'>
            <div className='content-item'>
              {searchResult.map((shirt, id) => (
                <div key={id} className=''>
                  <Cards shirt={shirt} />
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default SearchResult;
